import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntityRoleApi } from 'api';

export const findEntityRole = createAsyncThunk(
  'proof/findEntityRole',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await EntityRoleApi.findEntityRoles(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  list: Array<any>;
}

const initialState: IState = {
  list: [],
};

const entityRoleSlice = createSlice({
  name: 'proof',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(findEntityRole.fulfilled, (state, action) => {
      const { data } = action.payload;
      const newData = data.map((item: any) => {
        return {
          ...item,
          key: item.id,
          value: item.id,
        };
      });

      state.list = newData;
    });
  },
});

const { reducer: entityRoleReducer } = entityRoleSlice;

export default entityRoleReducer;
